export function paginateArray(array, page, rowsPerPage) {
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  return array.slice(startIndex, endIndex);
}
